module.exports = __webpack_public_path__ + "static/media/quote-dweck-potential-fr.05d1aa19.png";